/* eslint-disable */
// export const data = {
//   groupData: function () {
//     let data
//     // switch (appId) {
//     //   case '1906202140':
//     //     data = {
//     //       commentList: [
//     //         '欢迎回家！',
//     //         '为强大的中国骄傲！',
//     //         '十年文物追还的努力，两国友谊',
//     //         '那个微笑，等了上千年',
//     //         '希望大家多关注流失文物',
//     //         '时而感动，时而自豪。',
//     //         '祝愿祖国越来越强大！'
//     //       ],
//     //       urlDataArray: [
//     //         {
//     //           title: '归来：让更多的流失文物回家',
//     //           cover: '//cimg.vizen.cn/release/pic/ebceca9a9545e849115700a1fe97ef0c.jpg',
//     //           url: 'http://gs.people.com.cn/n2/2019/0626/c183348-33077031.html',
//     //           type: 'url'
//     //         },
//     //         {
//     //           title: '“归来—意大利返还中国流失文物展”开幕',
//     //           cover: '//cimg.vizen.cn/release/pic/a14bebf4ce7806c53ff22276a5dbd0aa.png',
//     //           url: 'http://www.sach.gov.cn/art/2019/4/24/art_722_154770.html',
//     //           type: 'url'
//     //         },
//     //         {
//     //           title: '意大利返还中国流失文物亮相国博',
//     //           cover: '//cimg.vizen.cn/release/thumbnail/videoThumbnail-15619741860000.png',
//     //           url: 'http://1251448083.vod2.myqcloud.com/0306eb86vodcq1251448083/fe4bff9f5285890790989688311/Qkak8qUJ2h8A.mp4',
//     //           type: 'video'
//     //         },
//     //         {
//     //           title: '意大利返还中国文物在国博展',
//     //           cover: '//cimg.vizen.cn/release/pic/32c780cc3b6ac92c3acd862cc38ca84b.png',
//     //           url: 'http://world.people.com.cn/n1/2019/0425/c1002-31048988.html',
//     //           type: 'url'
//     //         },
//     //         {
//     //           title: '归来！796件流失海外文物国博首展',
//     //           cover: '//cimg.vizen.cn/release/thumbnail/videoThumbnail-15619741950000.png',
//     //           url: 'http://1251448083.vod2.myqcloud.com/0306eb86vodcq1251448083/5cd4f0ec5285890790987310015/QTiLNkKcjQ8A.mp4',
//     //           type: 'video'
//     //         },
//     //         {
//     //           title: '“今天是一个盛大的节日”——记意大利返还796件套中国文物艺术品',
//     //           cover: '//cimg.vizen.cn/release/pic/5daac57d1ce75e9773fc455d028f9f98.png',
//     //           url: 'http://world.people.com.cn/n1/2019/0324/c1002-30991769.html',
//     //           type: 'url'
//     //         },
//     //         {
//     //           title: '769件套海外流失文物今天"到家"',
//     //           cover: '//cimg.vizen.cn/release/thumbnail/videoThumbnail-15619741500003.png',
//     //           url: 'http://1251448083.vod2.myqcloud.com/0306eb86vodcq1251448083/b13c57fb5285890790988672144/SKAbaus1OpwA.mp4',
//     //           type: 'video'
//     //         },
//     //         {
//     //           title: '意大利返还文物艺术品与祖国人民“团聚”',
//     //           cover: '//cimg.vizen.cn/release/pic/3df618fa0c0cbf531fe4f92a3c172e2c.png',
//     //           url: 'http://www.chnmuseum.cn/zx/mtgz/201904/t20190430_111422.shtml',
//     //           type: 'url'
//     //         },
//     //       ],
//     //       xcxUrlDataArray: [
//     //         {
//     //           title: '意大利返还中国流失文物亮相国博',
//     //           cover: '//cimg.vizen.cn/release/thumbnail/videoThumbnail-15619741860000.png',
//     //           url: 'http://1251448083.vod2.myqcloud.com/0306eb86vodcq1251448083/fe4bff9f5285890790989688311/Qkak8qUJ2h8A.mp4',
//     //           type: 'video'
//     //         },
//     //         {
//     //           title: '归来！796件流失海外文物国博首展',
//     //           cover: '//cimg.vizen.cn/release/thumbnail/videoThumbnail-15619741950000.png',
//     //           url: 'http://1251448083.vod2.myqcloud.com/0306eb86vodcq1251448083/5cd4f0ec5285890790987310015/QTiLNkKcjQ8A.mp4',
//     //           type: 'video'
//     //         },
//     //         {
//     //           title: '769件套海外流失文物今天"到家"',
//     //           cover: '//cimg.vizen.cn/release/thumbnail/videoThumbnail-15619741500003.png',
//     //           url: 'http://1251448083.vod2.myqcloud.com/0306eb86vodcq1251448083/b13c57fb5285890790988672144/SKAbaus1OpwA.mp4',
//     //           type: 'video'
//     //         },
//     //       ],
//     //       imagePageInfo: {
//     //         wenwu1: {
//     //           title: '圆圈网纹双耳彩陶壶',
//     //           tinyTitle: '双耳彩陶壶',
//     //           content: '朝代：新石器时代<br>高度：13cm<br>陶器由黏土塑形,经火烧制而成,是人类第一次根据自己的需要创造出的新物质。彩陶是在修整光滑的陶坯上先用矿物质颜料进行彩绘,再入窑烧制而成的。',
//     //           markerLeft: 13.320,
//     //           markerTop: 51.600,
//     //           id: '5d15affda027e30001df5650'
//     //         },
//     //         wenwu2: {
//     //           title: '彩绘陶俑',
//     //           tinyTitle: '彩绘陶俑',
//     //           content: '朝代：西汉<br>高度：45cm、44cm<br>这两件西汉时期的彩绘陶俑,五官和可服饰都施以彩绘,右手作持物状应该是原本持有木质的兵器,但已经腐朽。可以推测他们应该是军阵中的步兵形象。',
//     //           markerLeft: 13.320,
//     //           markerTop: 37.049,
//     //           id: '5d15b24ea027e30001df5664'
//     //         },
//     //         wenwu3: {
//     //           title: '彩绘陶骆驼',
//     //           tinyTitle: '彩绘陶骆驼',
//     //           content: '朝代：唐代<br>高度：57cm<br>骆驼被称为“沙漠之舟”,是古代丝绸之路最重要的交通工具。随着丝绸之路的畅通和繁荣,骆驼俑在墓葬中大量出现,多数作昂首嘶鸣状,非常生动。',
//     //           markerLeft: 86.578,
//     //           markerTop: 37.049,
//     //           id: '5d15afffa027e30001df5653'
//     //         },
//     //         wenwu4: {
//     //           title: '绿釉陶床',
//     //           tinyTitle: '绿釉陶床',
//     //           content: '朝代：明代<br>高度：44.5cm<br>拔步床模仿房屋建筑结构,底部是一个平座,架子床置于平座之上,床前设置围廊,中间是脚踏,两边可放置桌凳、灯盏等生活用品。踏入围廊,放下床帐,就能形成一个独立的生活空间。',
//     //           markerLeft: 86.578,
//     //           markerTop: 58.617,
//     //           id: '5d15b40202a9640001db80c2'
//     //         },
//     //         wenwu5: {
//     //           title: '黄釉武士陶俑',
//     //           tinyTitle: '武士陶俑',
//     //           content: '朝代：唐代<br>高度：22.5cm<br>唐朝墓葬中出土了大量武士俑,一方面反映了当时的丧葬习俗,另一方面也反映了当时社会背景下的尚武风俗。唐朝数百年间控制辽阔的疆域、抵御外来的侵扰、维持国内的安定,依靠的正是这些戎装的将士们。',
//     //           markerLeft: 86.578,
//     //           markerTop: 51.600,
//     //           id: '5d15b3fc02a9640001db80c0'
//     //         }
//     //       },
//     //       wenwuList: [
//     //         'wenwu1',
//     //         'wenwu2',
//     //         'wenwu3',
//     //         'wenwu4',
//     //         'wenwu5',
//     //       ],
//     //       circleMkList: [
//     //         {
//     //           name: 2,
//     //           markerLeft: 49.722,
//     //           markerTop: 64.262,
//     //           id: '5d15acd2a027e30001df5627',
//     //           isView: false
//     //         },
//     //         {
//     //           name: 5,
//     //           markerLeft: 9.257,
//     //           markerTop: 62.459,
//     //           id: '5d15b15ba027e30001df565f',
//     //           isView: false
//     //         },
//     //         {
//     //           name: 17,
//     //           markerLeft: 49.193,
//     //           markerTop: 33.115,
//     //           id: '5d15b26102a9640001db80b8',
//     //           isView: false
//     //         },
//     //         {
//     //           name: 20,
//     //           markerLeft: 32.002,
//     //           markerTop: 49.180,
//     //           id: '5d15b26702a9640001db80b9',
//     //           isView: false
//     //         },
//     //         {
//     //           name: 25,
//     //           markerLeft: 65.591,
//     //           markerTop: 41.639,
//     //           id: '5d15b26e02a9640001db80bb',
//     //           isView: false
//     //         },
//     //         {
//     //           name: 27,
//     //           markerLeft: 57.921,
//     //           markerTop: 48.361,
//     //           id: '5d15b271a027e30001df566f',
//     //           isView: false
//     //         },
//     //         {
//     //           name: 30,
//     //           markerLeft: 39.408,
//     //           markerTop: 41.967,
//     //           id: '5d15b277a027e30001df5672',
//     //           isView: false
//     //         },
//     //         {
//     //           name: 32,
//     //           markerLeft: 50.251,
//     //           markerTop: 53.115,
//     //           id: '5d15b27aa027e30001df5674',
//     //           isView: false
//     //         },
//     //         {
//     //           name: 40,
//     //           markerLeft: 79.344,
//     //           markerTop: 50.820,
//     //           id: '5d15b3fea027e30001df5679',
//     //           isView: true
//     //         },
//     //         {
//     //           name: 45,
//     //           markerLeft: 71.145,
//     //           markerTop: 62.787,
//     //           id: '5d15b4cf02a9640001db80c3',
//     //           isView: false
//     //         },
//     //       ]
//     //     }
//     //     break
//     // }
//     return data
//   }
// }

/* eslint-disable */

export const data = {
  specArray: [
    {
      index: 1,
      name: '坚强电网',
      type: 'dianwang'
    },
    {
      index: 2,
      name: '羊城风貌画卷',
      type: 'yangcheng'
    },
    {
      index: 3,
      name: '优质服务',
      type: 'fuwu'
    },
    {
      index: 4,
      name: '一度电的旅程',
      type: 'yidudian'
    },
  ],
  dianwangOptions: {
    guangzhou: {
      map: {
        title: '广州电网',
        url: './images/dianwang/guangzhou/map.png',
        width: 264,
        height: 377,
        zIndex: 1
      },
      totalIntro: {
        type: 'small',
        intro: '城市发展，电力先行，稳定的电力供应需要坚强可靠的电网来保障。广州作为特大型城市，是如何支撑我们的美好生活呢？'
      },
      plugIntro: null,
      button: {
        'map1-btn1': {
          groupId: 'map1-btn1',
          name: '获得电力名列前茅',
          width: 164,
          height: 27,
          left: -34,
          top: -26,
          url: './images/dianwang/guangzhou/intro-btn-1.png',
          selectUrl: './images/dianwang/guangzhou/intro-btn-1-selected.png',
          intro: '“获得电力”指标位列国家发改委评价第一梯队前列，助力广州优化营商环境。',
          introLeft: -35,
          introTop: 11,
        },
        'map1-btn2': {
          groupId: 'map1-btn2',
          name: '365座变电所',
          width: 164,
          height: 27,
          left: 138,
          top: 255,
          url: './images/dianwang/guangzhou/intro-btn-2.png',
          selectUrl: './images/dianwang/guangzhou/intro-btn-2-selected.png',
          intro: '广州拥有110千伏及以上变电站365座，是全国首个变电站总数超过300座的省会城市。',
          introLeft: -35,
          introTop: 292,
        },
        'map1-btn3': {
          groupId: 'map1-btn3',
          name: '每度电支持GDP',
          width: 106,
          height: 66,
          left: 20,
          bottom: 28,
          url: './images/dianwang/guangzhou/btn1.png',
          selectUrl: './images/dianwang/guangzhou/btn1-selected.png',
          intro: '坚强可靠的电网有力支持了城市的发展。<br>每度电支撑广州GDP 23.5元。',
          introLeft: 20,
          introBottom: 111,
          type: 'fixed'
        },
        'map1-btn4': {
          groupId: 'map1-btn4',
          name: '售电量',
          width: 106,
          height: 66,
          left: 134,
          bottom: 28,
          url: './images/dianwang/guangzhou/btn2.png',
          selectUrl: './images/dianwang/guangzhou/btn2-selected.png',
          intro: '广州是全国供电负荷密度最大的城市电网之一。',
          introLeft: 20,
          introBottom: 111,
          type: 'fixed'
        },
        'map1-btn5': {
          groupId: 'map1-btn5',
          name: '年平均停电时间',
          width: 106,
          height: 66,
          left: 249,
          bottom: 28,
          url: './images/dianwang/guangzhou/btn3.png',
          selectUrl: './images/dianwang/guangzhou/btn3-selected.png',
          intro: '城市客户年平均停电时间仅0.62小时/户，几乎感觉不到停电！',
          introLeft: 20,
          introBottom: 111,
          type: 'fixed'
        },
      },
      marker: [
        {
          class: 'guangzhou',
          left: 59 / 264 * 100 + '%',
          top: 108 / 377 * 100 + '%'
        },
        {
          class: 'guangzhou',
          left: 77 / 264 * 100 + '%',
          top: 143 / 377 * 100 + '%'
        },
        {
          class: 'guangzhou',
          left: 116 / 264 * 100 + '%',
          top: 175 / 377 * 100 + '%'
        },
        {
          class: 'guangzhou',
          left: 161 / 264 * 100 + '%',
          top: 175 / 377 * 100 + '%'
        },
        {
          class: 'guangzhou',
          left: 104 / 264 * 100 + '%',
          top: 246 / 377 * 100 + '%'
        },
        {
          class: 'guangzhou',
          left: 130 / 264 * 100 + '%',
          top: 296 / 377 * 100 + '%'
        },
      ]
    },
    guangdong: {
      map: {
        title: '广东电网',
        url: './images/dianwang/guangdong/map.png',
        width: 357,
        height: 273,
        left: 44,
        top: 103,
        zIndex: 1
      },
      totalIntro: {
        type: 'big',
        intro: '广州电网是全国供电负荷密度最大的城市电网之一，是粤港澳大湾区区域发展的核心引擎。大湾区的发展离不开广东电网和南方电网的保驾护航，近年来，南方电网将先进技术与业务深度融合，加快互联网、大数据、人工智能和区块链等技术的应用，大力建设数字南网助力粤港澳大湾区的建设与发展。'
      },
      plugIntro: null,
      button: {
        'map2-btn1': {
          groupId: 'map2-btn1',
          name: '圆圈',
          width: 0,
          height: 0,
          left: 0,
          top: 0,
          url: './images/dianwang/guangdong/map.png',
          selectUrl: './images/dianwang/guangdong/map.png',
          intro: '广东电网以珠江三角洲地区500千伏主干环网为中心，向东西两翼及粤北延伸。通过海底电缆与海南电网相联，连续多年向港澳供电。',
          introLeft: 19,
          introTop: 375,
          type: 'fixed'
        },
        'map2-btn2': {
          groupId: 'map2-btn2',
          name: '每度电支持GDP',
          width: 106,
          height: 66,
          left: 20,
          bottom: 28,
          url: './images/dianwang/guangdong/btn1.png',
          selectUrl: './images/dianwang/guangdong/btn1-selected.png',
          intro: '广东作为全国第一经济大省，供电面积仅占南方电网18%，供电人口占比却超过了44%。',
          introLeft: 20,
          introBottom: 111,
          type: 'fixed'
        },
        'map2-btn3': {
          groupId: 'map2-btn2',
          name: '售电量',
          width: 106,
          height: 66,
          left: 134,
          bottom: 28,
          url: './images/dianwang/guangdong/btn2.png',
          selectUrl: './images/dianwang/guangdong/btn2-selected.png',
          type: 'fixed'
        },
        'map2-btn4': {
          groupId: 'map2-btn2',
          name: '年平均停电时间',
          width: 106,
          height: 66,
          left: 249,
          bottom: 28,
          url: './images/dianwang/guangdong/btn3.png',
          selectUrl: './images/dianwang/guangdong/btn3-selected.png',
          type: 'fixed'
        },
      },
      marker: [
        {
          class: 'guangzhou',
          left: 170 / 357 * 100 + '%',
          top: 75 / 273 * 100 + '%'
        },
        {
          class: 'guangzhou',
          left: 180 / 357 * 100 + '%',
          top: 154 / 273 * 100 + '%'
        },
        {
          class: 'guangzhou',
          left: 209 / 357 * 100 + '%',
          top: 156 / 273 * 100 + '%'
        },
        {
          class: 'text',
          left: 202 / 357 * 100 + '%',
          top: 79 / 273 * 100 + '%',
          text: '广州'
        },
        {
          class: 'text',
          left: 152 / 357 * 100 + '%',
          top: 156 / 273 * 100 + '%',
          text: '澳门'
        },
        {
          class: 'text',
          left: 234 / 357 * 100 + '%',
          top: 159 / 273 * 100 + '%',
          text: '香港'
        },
        {
          class: 'guangdong',
          left: 37 / 357 * 100 + '%',
          top: -28 / 273 * 100 + '%'
        },
      ]
    },
    nanfang: {
      map: {
        title: '南方电网',
        url: './images/dianwang/nanfang/map.png',
        width: 354,
        height: 220,
        zIndex: 1
      },
      totalIntro: {
        type: 'big',
        intro: '广东的电从哪里来？依靠南方电网西电东送工程，西部清洁的水电源源不断地输送到东部。南方电网明确了“向智能电网运营商、能源产业价值链整合商、能源生态系统服务商转型”的战略取向，依托数字南网，实现能源发展合作共赢，助力广东绿色发展和高质量发展，为支持广东打赢蓝天保卫战做出巨大贡献。'
      },
      plugIntro: {
        type: 'normal',
        intro: '广州供电局作为广东电网的中心、窗口、标杆，始终将电网发展融入粤港澳大湾区建设格局之中，建设更坚强、可靠、智能的电网，助力广州实现老城市新活力和“四个出新出彩”。'
      },
      button: {
        'map3-btn1': {
          groupId: 'map3-btn1',
          name: '全球500强',
          width: 106,
          height: 66,
          left: 20,
          bottom: 28,
          url: './images/dianwang/nanfang/btn1.png',
          selectUrl: './images/dianwang/nanfang/btn1-selected.png',
          intro: '中国南方电网公司成立于2002年12月29日，<br>世界500强排名105名。',
          introLeft: 20,
          introBottom: 111,
          type: 'fixed'
        },
        'map3-btn2': {
          groupId: 'map3-btn2',
          name: '供电面积',
          width: 106,
          height: 66,
          left: 134,
          bottom: 28,
          url: './images/dianwang/nanfang/btn2.png',
          selectUrl: './images/dianwang/nanfang/btn2-selected.png',
          intro: '南方电网覆盖广东、广西、云南、贵州、海南五省区和港澳地区，东西跨度近2000公里，并通过海底电缆与海南电网相联，支撑全国17.6%的GDP产值。',
          introLeft: 20,
          introBottom: 111,
          type: 'fixed'
        },
        'map3-btn3': {
          groupId: '',
          name: '售电量',
          width: 106,
          height: 66,
          left: 249,
          bottom: 28,
          url: './images/dianwang/nanfang/btn3.png',
          selectUrl: './images/dianwang/nanfang/btn3.png',
          type: 'fixed'
        },
        'map3-btn4': {
          groupId: 'map3-btn4',
          name: '云南省',
          width: 155,
          height: 161,
          left: 0,
          top: 0,
          url: '',
          selectUrl: './images/dianwang/nanfang/yunnan.png',
          introUrl: './images/dianwang/nanfang/yunnan-intro.png',
          introLeft: 8,
          introTop: 178,
        },
        'map3-btn6': {
          groupId: 'map3-btn6',
          name: '广西省',
          width: 136,
          height: 98,
          left: 125,
          top: 59,
          url: '',
          selectUrl: './images/dianwang/nanfang/guangxi.png',
          introUrl: './images/dianwang/nanfang/guangxi-intro.png',
          introLeft: 105,
          introTop: 174,
        },
        'map3-btn5': {
          groupId: 'map3-btn5',
          name: '贵州省',
          width: 106,
          height: 93,
          left: 109,
          top: 0,
          url: '',
          selectUrl: './images/dianwang/nanfang/guizhou.png',
          introUrl: './images/dianwang/nanfang/guizhou-intro.png',
          introLeft: 83,
          introTop: 110,
        },
        'map3-btn7': {
          groupId: 'map3-btn7',
          name: '广东省',
          width: 134,
          height: 103,
          left: 219,
          top: 76,
          url: '',
          selectUrl: './images/dianwang/nanfang/guangdong.png',
          introUrl: './images/dianwang/nanfang/guangdong-intro.png',
          introLeft: 159,
          introTop: 196,
        },
        'map3-btn8': {
          groupId: 'map3-btn8',
          name: '海南省',
          width: 44,
          height: 38,
          left: 200,
          top: 181,
          url: '',
          selectUrl: './images/dianwang/nanfang/hainan.png',
          introUrl: './images/dianwang/nanfang/hainan-intro.png',
          introLeft: 105,
          introTop: 235,
        },
        'map3-btn9': {
          groupId: 'map3-btn9',
          name: '三沙',
          width: 56,
          height: 15,
          left: 300,
          top: 260,
          url: '',
          selectUrl: './images/dianwang/nanfang/sansha.png',
          introUrl: './images/dianwang/nanfang/sansha-intro.png',
          introLeft: 45,
          introTop: 190,
        },
      },
      marker: [
        // {
        //   class: 'nanfang',
        //   left: 43 / 354 * 100 + '%',
        //   top: 54 / 220 * 100 + '%'
        // },
        // {
        //   class: 'nanfang',
        //   left: 121 / 354 * 100 + '%',
        //   top: 113 / 220 * 100 + '%'
        // },
        // {
        //   class: 'nanfang',
        //   left: 139 / 354 * 100 + '%',
        //   top: 67 / 220 * 100 + '%'
        // },
        // {
        //   class: 'nanfang',
        //   left: 151 / 354 * 100 + '%',
        //   top: 51 / 220 * 100 + '%'
        // },
        // {
        //   class: 'nanfang',
        //   left: (12 + 155) / 354 * 100 + '%',
        //   top: 52 / 220 * 100 + '%'
        // },
        // {
        //   class: 'nanfang',
        //   left: (14 + 155) / 354 * 100 + '%',
        //   top: 29 / 220 * 100 + '%'
        // },
        // {
        //   class: 'nanfang',
        //   left: (17 + 155) / 354 * 100 + '%',
        //   top: 117 / 220 * 100 + '%'
        // },
        // {
        //   class: 'nanfang',
        //   left: (112 + 155) / 354 * 100 + '%',
        //   top: 102 / 220 * 100 + '%'
        // },
        // {
        //   class: 'nanfang',
        //   left: (146 + 155) / 354 * 100 + '%',
        //   top: 104 / 220 * 100 + '%'
        // },
        // {
        //   class: 'nanfang',
        //   left: (77 + 155) / 354 * 100 + '%',
        //   top: 146 / 220 * 100 + '%'
        // },
        // {
        //   class: 'nanfang',
        //   left: (104 + 155) / 354 * 100 + '%',
        //   top: 118 / 220 * 100 + '%'
        // },
        // {
        //   class: 'nanfang',
        //   left: (130 + 155) / 354 * 100 + '%',
        //   top: 87 / 220 * 100 + '%'
        // },
        // {
        //   class: 'nanfang',
        //   left: (153 + 155) / 354 * 100 + '%',
        //   top: 95 / 220 * 100 + '%'
        // },
        // {
        //   class: 'nanfang',
        //   left: (57 + 155) / 354 * 100 + '%',
        //   top: (33 + 161) / 220 * 100 + '%'
        // },
        {
          class: 'nanfang',
          left: 300 / 354 * 100 + '%',
          top: 265 / 220 * 100 + '%'
        },
        {
          class: 'text',
          left: 320 / 354 * 100 + '%',
          top: 260 / 220 * 100 + '%',
          text: '三沙'
        },
        {
          class: 'text',
          left: 22 / 354 * 100 + '%',
          top: 78 / 220 * 100 + '%',
          text: '云南'
        },
        {
          class: 'text',
          left: (26 + 155) / 354 * 100 + '%',
          top: 46 / 220 * 100 + '%',
          text: '贵州'
        },
        {
          class: 'text',
          left: (29 + 155) / 354 * 100 + '%',
          top: 124 / 220 * 100 + '%',
          text: '广西'
        },
        {
          class: 'text',
          left: (162 + 155) / 354 * 100 + '%',
          top: 103 / 220 * 100 + '%',
          text: '广东'
        },
        {
          class: 'text',
          left: (84 + 155) / 354 * 100 + '%',
          top: (38 + 161) / 220 * 100 + '%',
          text: '海南'
        },
        // {
        //   class: 'nanfang2',
        //   left: 27 / 354 * 100 + '%',
        //   top: 30 / 220 * 100 + '%'
        // },
        // {
        //   class: 'nanfang2',
        //   left: 41 / 354 * 100 + '%',
        //   top: 126 / 220 * 100 + '%'
        // },
        // {
        //   class: 'nanfang2',
        //   left: 131 / 354 * 100 + '%',
        //   top: 31 / 220 * 100 + '%'
        // },
        // {
        //   class: 'nanfang2',
        //   left: (99 + 155) / 354 * 100 + '%',
        //   top: 132 / 220 * 100 + '%'
        // },
        // {
        //   class: 'nanfang2',
        //   left: (126 + 155) / 354 * 100 + '%',
        //   top: 113 / 220 * 100 + '%'
        // },
        {
          class: 'line',
          left: 40 / 354 * 100 + '%',
          top: -7 / 220 * 100 + '%'
        },
        {
          class: 'line2',
          left: 210 / 354 * 100 + '%',
          top: 150 / 220 * 100 + '%'
        },
      ]
    },
  },
  dianwangPCOptions: {
    guangzhou: {
      map: {
        title: '广州电网',
        url: './images/dianwang/guangzhou/map.png',
        width: 579,
        height: 830,
        zIndex: 1
      },
      totalIntro: {
        type: 'small',
        intro: '城市发展，电力先行，稳定的电力供应需要坚强可靠的电网来保障。广州作为特大型城市，是如何支撑我们的美好生活呢？'
      },
      plugIntro: null,
      button: {
        'map1-btn1': {
          groupId: 'map1-btn1',
          name: '获得电力名列前茅',
          width: 307,
          height: 50,
          left: -141,
          top: 29,
          url: './images/dianwang/guangzhou/intro-btn-1.png',
          selectUrl: './images/dianwang/guangzhou/intro-btn-1-selected.png',
          intro: '“获得电力”指标位列国家发改委评价第一梯队前列，助力广州优化营商环境。',
          introLeft: -141,
          introTop: 94,
        },
        'map1-btn2': {
          groupId: 'map1-btn2',
          name: '365座变电所',
          width: 273,
          height: 50,
          left: 506,
          top: 506,
          url: './images/dianwang/guangzhou/intro-btn-2.png',
          selectUrl: './images/dianwang/guangzhou/intro-btn-2-selected.png',
          intro: '广州拥有110千伏及以上变电站365座，是全国首个变电站总数超过300座的省会城市。',
          introLeft: 506,
          introTop: 566,
        },
        'map1-btn3': {
          groupId: 'map1-btn3',
          name: '每度电支持GDP',
          width: 276,
          height: 172,
          right: 148,
          top: 219,
          url: './images/dianwang/guangzhou/btn1.png',
          selectUrl: './images/dianwang/guangzhou/btn1-selected.png',
          intro: '坚强可靠的电网有力支持了城市的发展，每度电支撑广州GDP23.5元！',
          introRight: 434,
          introTop: 219,
          type: 'fixed'
        },
        'map1-btn4': {
          groupId: 'map1-btn4',
          name: '售电量',
          width: 276,
          height: 172,
          right: 148,
          top: 455,
          url: './images/dianwang/guangzhou/btn2.png',
          selectUrl: './images/dianwang/guangzhou/btn2-selected.png',
          intro: '广州是全国供电负荷密度最大的城市电网之一。',
          introRight: 434,
          introTop: 455,
          type: 'fixed'
        },
        'map1-btn5': {
          groupId: 'map1-btn5',
          name: '年平均停电时间',
          width: 276,
          height: 172,
          right: 148,
          top: 690,
          url: './images/dianwang/guangzhou/btn3.png',
          selectUrl: './images/dianwang/guangzhou/btn3-selected.png',
          intro: '城市客户年平均停电时间仅0.62小时/户，几乎感觉不到停电！',
          introRight: 434,
          introTop: 690,
          type: 'fixed'
        },
      },
      marker: [
        {
          class: 'guangzhou',
          left: 59 / 264 * 100 + '%',
          top: 108 / 377 * 100 + '%'
        },
        {
          class: 'guangzhou',
          left: 77 / 264 * 100 + '%',
          top: 143 / 377 * 100 + '%'
        },
        {
          class: 'guangzhou',
          left: 116 / 264 * 100 + '%',
          top: 175 / 377 * 100 + '%'
        },
        {
          class: 'guangzhou',
          left: 161 / 264 * 100 + '%',
          top: 175 / 377 * 100 + '%'
        },
        {
          class: 'guangzhou',
          left: 104 / 264 * 100 + '%',
          top: 246 / 377 * 100 + '%'
        },
        {
          class: 'guangzhou',
          left: 130 / 264 * 100 + '%',
          top: 296 / 377 * 100 + '%'
        },
      ]
    },
    guangdong: {
      map: {
        title: '广东电网',
        url: './images/dianwang/guangdong/map.png',
        width: 927,
        height: 708,
        zIndex: 1
      },
      totalIntro: {
        type: 'big',
        intro: '广州电网是全国供电负荷密度最大的城市电网之一，是粤港澳大湾区区域发展的核心引擎。大湾区的发展离不开广东电网和南方电网的保驾护航，近年来，南方电网将先进技术与业务深度融合，加快互联网、大数据、人工智能和区块链等技术的应用，大力建设数字南网助力粤港澳大湾区的建设与发展。'
      },
      plugIntro: null,
      button: {
        'map2-btn1': {
          groupId: 'map2-btn1',
          name: '圆圈',
          width: 0,
          height: 0,
          left: 0,
          top: 0,
          url: './images/dianwang/guangdong/map.png',
          selectUrl: './images/dianwang/guangdong/map.png',
          intro: '广东电网以珠江三角洲地区500千伏主干环网为中心，向东西两翼及粤北延伸。通过海底电缆与海南电网相联，连续多年向港澳供电。',
          introLeft: 360,
          introBottom: 200,
          type: 'fixed'
        },
        'map2-btn2': {
          groupId: 'map2-btn2',
          name: '每度电支持GDP',
          width: 276,
          height: 172,
          right: 148,
          top: 219,
          url: './images/dianwang/guangdong/btn1.png',
          selectUrl: './images/dianwang/guangdong/btn1-selected.png',
          intro: '广东作为全国第一经济大省，供电面积仅占南方电网18%，供电人口占比却超过了44%。',
          introRight: 434,
          introTop: 455,
          type: 'fixed'
        },
        'map2-btn3': {
          groupId: 'map2-btn2',
          name: '售电量',
          width: 276,
          height: 172,
          right: 148,
          top: 455,
          url: './images/dianwang/guangdong/btn2.png',
          selectUrl: './images/dianwang/guangdong/btn2-selected.png',
          type: 'fixed'
        },
        'map2-btn4': {
          groupId: 'map2-btn2',
          name: '年平均停电时间',
          width: 276,
          height: 172,
          right: 148,
          top: 690,
          url: './images/dianwang/guangdong/btn3.png',
          selectUrl: './images/dianwang/guangdong/btn3-selected.png',
          type: 'fixed'
        },
      },
      marker: [
        {
          class: 'guangzhou',
          left: 170 / 357 * 100 + '%',
          top: 75 / 273 * 100 + '%'
        },
        {
          class: 'guangzhou',
          left: 180 / 357 * 100 + '%',
          top: 154 / 273 * 100 + '%'
        },
        {
          class: 'guangzhou',
          left: 209 / 357 * 100 + '%',
          top: 156 / 273 * 100 + '%'
        },
        {
          class: 'text',
          left: 202 / 357 * 100 + '%',
          top: 79 / 273 * 100 + '%',
          text: '广州'
        },
        {
          class: 'text',
          left: 152 / 357 * 100 + '%',
          top: 156 / 273 * 100 + '%',
          text: '澳门'
        },
        {
          class: 'text',
          left: 234 / 357 * 100 + '%',
          top: 159 / 273 * 100 + '%',
          text: '香港'
        },
        {
          class: 'guangdong',
          left: 37 / 357 * 100 + '%',
          top: -28 / 273 * 100 + '%'
        },
      ]
    },
    nanfang: {
      map: {
        title: '南方电网',
        url: './images/dianwang/nanfang/map.png',
        width: 708,
        height: 440,
        zIndex: 1
      },
      totalIntro: {
        type: 'big',
        intro: '广东的电从哪里来？依靠南方电网西电东送工程，西部清洁的水电源源不断地输送到东部。南方电网明确了“向智能电网运营商、能源产业价值链整合商、能源生态系统服务商转型”的战略取向，依托数字南网，实现能源发展合作共赢，助力广东绿色发展和高质量发展，为支持广东打赢蓝天保卫战做出巨大贡献。'
      },
      plugIntro: {
        type: 'normal',
        intro: '广州供电局作为广东电网的中心、窗口、标杆，始终将电网发展融入粤港澳大湾区建设格局之中，建设更坚强、可靠、智能的电网，助力广州实现老城市新活力和“四个出新出彩”。'
      },
      button: {
        'map3-btn1': {
          groupId: 'map3-btn1',
          name: '全球500强',
          width: 276,
          height: 172,
          right: 148,
          top: 219,
          url: './images/dianwang/nanfang/btn1.png',
          selectUrl: './images/dianwang/nanfang/btn1-selected.png',
          intro: '中国南方电网公司成立于2002年12月29日，<br>世界500强排名105名。',
          introRight: 434,
          introTop: 219,
          type: 'fixed'
        },
        'map3-btn2': {
          groupId: 'map3-btn2',
          name: '供电面积',
          width: 276,
          height: 172,
          right: 148,
          top: 455,
          url: './images/dianwang/nanfang/btn2.png',
          selectUrl: './images/dianwang/nanfang/btn2-selected.png',
          intro: '南方电网覆盖广东、广西、云南、贵州、海南五省区和港澳地区，东西跨度近2000公里，并通过海底电缆与海南电网相联，支撑全国17.6%的GDP产值。',
          introRight: 434,
          introTop: 455,
          type: 'fixed'
        },
        'map3-btn3': {
          groupId: '',
          name: '售电量',
          width: 276,
          height: 172,
          right: 148,
          top: 690,
          url: './images/dianwang/nanfang/btn3.png',
          selectUrl: './images/dianwang/nanfang/btn3.png',
          type: 'fixed'
        },
        'map3-btn4': {
          groupId: 'map3-btn4',
          name: '云南省',
          width: 155*2,
          height: 161*2,
          left: 0,
          top: 0,
          url: '',
          selectUrl: './images/dianwang/nanfang/yunnan.png',
          introUrl: './images/dianwang/nanfang/yunnan-intro.png',
          introLeft: 8*2,
          introTop: 178*2,
        },
        'map3-btn6': {
          groupId: 'map3-btn6',
          name: '广西省',
          width: 136*2,
          height: 98*2,
          left: 125*2,
          top: 59*2,
          url: '',
          selectUrl: './images/dianwang/nanfang/guangxi.png',
          introUrl: './images/dianwang/nanfang/guangxi-intro.png',
          introLeft: 105*2,
          introTop: 174*2,
        },
        'map3-btn5': {
          groupId: 'map3-btn5',
          name: '贵州省',
          width: 106*2,
          height: 93*2,
          left: 109*2,
          top: 0,
          url: '',
          selectUrl: './images/dianwang/nanfang/guizhou.png',
          introUrl: './images/dianwang/nanfang/guizhou-intro.png',
          introLeft: 83*2,
          introTop: 110*2,
        },
        'map3-btn7': {
          groupId: 'map3-btn7',
          name: '广东省',
          width: 134*2,
          height: 103*2,
          left: 219*2,
          top: 76*2,
          url: '',
          selectUrl: './images/dianwang/nanfang/guangdong.png',
          introUrl: './images/dianwang/nanfang/guangdong-intro.png',
          introLeft: 159*2,
          introTop: 196*2,
        },
        'map3-btn8': {
          groupId: 'map3-btn8',
          name: '海南省',
          width: 44*2,
          height: 38*2,
          left: 200*2,
          top: 181*2,
          url: '',
          selectUrl: './images/dianwang/nanfang/hainan.png',
          introUrl: './images/dianwang/nanfang/hainan-intro.png',
          introLeft: 105*2,
          introTop: 235*2,
        },
        'map3-btn9': {
          groupId: 'map3-btn9',
          name: '三沙',
          width: 56*2,
          height: 15*2,
          left: 300*2,
          top: 260*2,
          url: '',
          selectUrl: './images/dianwang/nanfang/sansha.png',
          introUrl: './images/dianwang/nanfang/sansha-intro.png',
          introLeft: 96*2,
          introTop: 200*2,
        },
      },
      marker: [
        // {
        //   class: 'nanfang',
        //   left: 43 / 354 * 100 + '%',
        //   top: 54 / 220 * 100 + '%'
        // },
        // {
        //   class: 'nanfang',
        //   left: 121 / 354 * 100 + '%',
        //   top: 113 / 220 * 100 + '%'
        // },
        // {
        //   class: 'nanfang',
        //   left: 139 / 354 * 100 + '%',
        //   top: 67 / 220 * 100 + '%'
        // },
        // {
        //   class: 'nanfang',
        //   left: 151 / 354 * 100 + '%',
        //   top: 51 / 220 * 100 + '%'
        // },
        // {
        //   class: 'nanfang',
        //   left: (12 + 155) / 354 * 100 + '%',
        //   top: 52 / 220 * 100 + '%'
        // },
        // {
        //   class: 'nanfang',
        //   left: (14 + 155) / 354 * 100 + '%',
        //   top: 29 / 220 * 100 + '%'
        // },
        // {
        //   class: 'nanfang',
        //   left: (17 + 155) / 354 * 100 + '%',
        //   top: 117 / 220 * 100 + '%'
        // },
        // {
        //   class: 'nanfang',
        //   left: (112 + 155) / 354 * 100 + '%',
        //   top: 102 / 220 * 100 + '%'
        // },
        // {
        //   class: 'nanfang',
        //   left: (146 + 155) / 354 * 100 + '%',
        //   top: 104 / 220 * 100 + '%'
        // },
        // {
        //   class: 'nanfang',
        //   left: (77 + 155) / 354 * 100 + '%',
        //   top: 146 / 220 * 100 + '%'
        // },
        // {
        //   class: 'nanfang',
        //   left: (104 + 155) / 354 * 100 + '%',
        //   top: 118 / 220 * 100 + '%'
        // },
        // {
        //   class: 'nanfang',
        //   left: (130 + 155) / 354 * 100 + '%',
        //   top: 87 / 220 * 100 + '%'
        // },
        // {
        //   class: 'nanfang',
        //   left: (153 + 155) / 354 * 100 + '%',
        //   top: 95 / 220 * 100 + '%'
        // },
        // {
        //   class: 'nanfang',
        //   left: (57 + 155) / 354 * 100 + '%',
        //   top: (33 + 161) / 220 * 100 + '%'
        // },
        {
          class: 'nanfang',
          left: 300 / 354 * 100 + '%',
          top: 265 / 220 * 100 + '%'
        },
        {
          class: 'text',
          left: 320 / 354 * 100 + '%',
          top: 260 / 220 * 100 + '%',
          text: '三沙'
        },
        {
          class: 'text',
          left: 22 / 354 * 100 + '%',
          top: 78 / 220 * 100 + '%',
          text: '云南'
        },
        {
          class: 'text',
          left: (26 + 155) / 354 * 100 + '%',
          top: 46 / 220 * 100 + '%',
          text: '贵州'
        },
        {
          class: 'text',
          left: (29 + 155) / 354 * 100 + '%',
          top: 124 / 220 * 100 + '%',
          text: '广西'
        },
        {
          class: 'text',
          left: (162 + 155) / 354 * 100 + '%',
          top: 103 / 220 * 100 + '%',
          text: '广东'
        },
        {
          class: 'text',
          left: (84 + 155) / 354 * 100 + '%',
          top: (38 + 161) / 220 * 100 + '%',
          text: '海南'
        },
        // {
        //   class: 'nanfang2',
        //   left: 27 / 354 * 100 + '%',
        //   top: 30 / 220 * 100 + '%'
        // },
        // {
        //   class: 'nanfang2',
        //   left: 41 / 354 * 100 + '%',
        //   top: 126 / 220 * 100 + '%'
        // },
        // {
        //   class: 'nanfang2',
        //   left: 131 / 354 * 100 + '%',
        //   top: 31 / 220 * 100 + '%'
        // },
        // {
        //   class: 'nanfang2',
        //   left: (99 + 155) / 354 * 100 + '%',
        //   top: 132 / 220 * 100 + '%'
        // },
        // {
        //   class: 'nanfang2',
        //   left: (126 + 155) / 354 * 100 + '%',
        //   top: 113 / 220 * 100 + '%'
        // },
        {
          class: 'line',
          left: 40 / 354 * 100 + '%',
          top: -7 / 220 * 100 + '%'
        },
        {
          class: 'line2',
          left: 210 / 354 * 100 + '%',
          top: 150 / 220 * 100 + '%'
        },
      ]
    },
  },
  willHideMarkersPanoIdJson: {
    '1C0715CEAA3F48B2A20A46789BE6E864': {
      'panoIdArray': ['10E88FA96A5948C290453A92B7212076','8F9E170AA6FC4421A4F546E519CEBB4F'],
      'indexArray': [],
    },
    '2389E45EEBF84972BB45B9F49F44D397': {
      'panoIdArray': ['10E88FA96A5948C290453A92B7212076','8F9E170AA6FC4421A4F546E519CEBB4F','03EB7B1D9A624D08B817D3EDC51F0D72'],
      'indexArray': [],
    },
    'FBC2A4BA75F14A72AD993BDF0C13DDFA': {
      'panoIdArray': ['03EB7B1D9A624D08B817D3EDC51F0D72'],
      'indexArray': [],
    },
    '21CA8CA7EBBE45F09424F5722F93627D': {
      'panoIdArray': ['03EB7B1D9A624D08B817D3EDC51F0D72','B0733650071D498FBEC360A06F194503','1C0715CEAA3F48B2A20A46789BE6E864','10E88FA96A5948C290453A92B7212076'],
      'indexArray': [],
    },
    'BB5ADC62A2AF4AE0BE91524D51B73DAE': {
      'panoIdArray': ['44E13B37429F48888D78288EBA0F0E1D'],
      'indexArray': [],
    },
    '8F9E170AA6FC4421A4F546E519CEBB4F': {
      'panoIdArray': ['10E88FA96A5948C290453A92B7212076','1C0715CEAA3F48B2A20A46789BE6E864','2389E45EEBF84972BB45B9F49F44D397','FBC2A4BA75F14A72AD993BDF0C13DDFA','21CA8CA7EBBE45F09424F5722F93627D','03EB7B1D9A624D08B817D3EDC51F0D72','EF6CBB5CAA4642B18CE981013C7CC0DF','82CEC5F3DF88481EBC78C3560202367E'],
      'indexArray': [],
    },
    '1F25EFE90AFF4FBE8E9191AFDA69CCD6': {
      'panoIdArray': ['EF6CBB5CAA4642B18CE981013C7CC0DF','82CEC5F3DF88481EBC78C3560202367E'],
      'indexArray': [],
    },
    'E1D3BE1A4DF044D1AF3907896F171CA9': {
      'panoIdArray': ['7A3AC4FCB31B45F0890AEC21E2ED7A47'],
      'indexArray': [],
    },
    '82CEC5F3DF88481EBC78C3560202367E': {
      'panoIdArray': ['A544601799C24559A5E2920584D545DA','76AA97A4EA4C439AB5819ACFC06DAE1E'],
      'indexArray': [],
    },
    '5F4F33B083E247C0898F71E5552DBD3D': {
      'panoIdArray': ['76AA97A4EA4C439AB5819ACFC06DAE1E'],
      'indexArray': [],
    },
    '76AA97A4EA4C439AB5819ACFC06DAE1E': {
      'panoIdArray': ['5FD3EA3D255D4F9FBB4F325BD79AC9C3','2303DB077D2C4047898719E6990ADACE','F776D11729AB4AB9A406A3ED1A519A2B','BDAEA93D36A94D61A1766017548F8E20','15E638DC55CD4543814F520D748A3DE1','2B390BFADBD1495CB1D56522B09ADAE3'],
      'indexArray': [],
    },
    'A916AADEACAB45658A6B27E704854A2B': {
      'panoIdArray': ['BDAEA93D36A94D61A1766017548F8E20','15E638DC55CD4543814F520D748A3DE1','2B390BFADBD1495CB1D56522B09ADAE3'],
      'indexArray': [],
    },
    '664CA8BEC2D84429ADE2D97469FE4798': {
      'panoIdArray': ['BBE4ED260AEC4F53A7D38B833C5DE20B', '6EBC401922794781926A911FEED21343', '0EF55043B55C4CCD962ADBD8034A2B70', '41ABE6D6A9484C8280C6BE6148F2C67A'],
      'indexArray': [],
    },
    '23E5DC4561D34751B609AA75B29C000A': {
      'panoIdArray': ['568D68B152CF43F7AF2B989D39B6A7EE'],
      'indexArray': [],
    },
    '41ABE6D6A9484C8280C6BE6148F2C67A': {
      'panoIdArray': ['BBE4ED260AEC4F53A7D38B833C5DE20B',
        '664CA8BEC2D84429ADE2D97469FE4798',
        '622637AA7EE54A6993E6554E6C58039D',
        '4F111CB55BD34114868D6AC355680430'],
      'indexArray': [],
    },
    '342022976F2A406591C5726C834ABE01': {
      'panoIdArray': [
        'E7F7FB652A914642B80481AB4DB71A88',
        '04FDB89422E1413BA1943928D7BDB525',
        '2E7DCD9FC458406081AE78F0E184C32A',
      ],
      'indexArray': [],
    },
    '246A7E402EE940AD8488966C50C57442': {
      'panoIdArray': [
        '2E7DCD9FC458406081AE78F0E184C32A',
        '940AC696B2704CB8BF211425DB513843',
      ],
      'indexArray': [],
    },
    'D1A5A78FA4194E00ACA249D0E29EEAFB': {
      'panoIdArray': [
        '5EB96F304728456EB7872E2AF8B4126F',
        '05E7952DAD7A492CBF13CDEF3EBFBB59',
        '0EF55043B55C4CCD962ADBD8034A2B70',
      ],
      'indexArray': [],
    },
    '4D82FE2B075345F8935184476DCE8E4B': {
      'panoIdArray': [
        '4D16BF0BB0FD4B94B7CB5246AFEFB67D',
        'BFFCE93CC5D34940854D518551E19EBA',
      ],
      'indexArray': [],
    },
    'FAB25FF72FE24031A0542E83C460083B': {
      'panoIdArray': [
        'BFFCE93CC5D34940854D518551E19EBA',
      ],
      'indexArray': [],
    },
    '5C1E4781E1AF4BBAB1F2357855363C64': {
      'panoIdArray': [
        '96CDDBE63A8C4388929D543A9951AAAB',
        '589B4965F73B41DE95AB32EB89284D73',
        '68BB2DF14BAA44BFB18FA3704584511F',
        'F6BBA47FCEC8408FB43312563E4DD3AE',
        'B8304B58609D482CBBB17242320E4EB2',
        'DBAE649A31814CF995EE514C6E6216E9',
        'D52A41B1EEAE409FB9E95886089506B4',
      ],
      'indexArray': [],
    },
    '4CFD787BF4794316A04910C08B6305A7': {
      'panoIdArray': [
        'E6B4E85B2CD44175A1B55826D6C013CF',
        'B48E94617B2B4BC7BEEAC13330C65D83',
      ],
      'indexArray': [],
    },
    'C92B860DC97D4C4CAC2AB0F93F9636C5': {
      'panoIdArray': [
        'B48E94617B2B4BC7BEEAC13330C65D83',
        '3EB4AD39A2284B3F811EB5BC949C6AA4',
        '657DF7C19DB1476B829388CD80C2C6F7',
      ],
      'indexArray': [],
    },
    '3EB4AD39A2284B3F811EB5BC949C6AA4': {
      'panoIdArray': [
        '657DF7C19DB1476B829388CD80C2C6F7',
      ],
      'indexArray': [],
    },
    '657DF7C19DB1476B829388CD80C2C6F7': {
      'panoIdArray': [
        '3EB4AD39A2284B3F811EB5BC949C6AA4',
        'D12D818BDBCB43DB95B125FE105A60A7',
      ],
      'indexArray': [],
    },
    '7A5FEEF5AFDA4CEA8D268742318DD932': {
      'panoIdArray': [
        '80E62F3A83BB40279B4755BA6494626E',
        '6D514B686C8F4627A0685601DAB51052',
        '68BB2DF14BAA44BFB18FA3704584511F',
      ],
      'indexArray': [],
    },
    '96CDDBE63A8C4388929D543A9951AAAB': {
      'panoIdArray': [
        'B8304B58609D482CBBB17242320E4EB2',
        '5C1E4781E1AF4BBAB1F2357855363C64',
      ],
      'indexArray': [],
    },
    'DBAE649A31814CF995EE514C6E6216E9': {
      'panoIdArray': [
        '4A182DB3CAAD4E2786CB61180EE0B5B5',
        '3025664EBA9B4962A8BCAEE08669B4DE',
      ],
      'indexArray': [],
    },
    '4A182DB3CAAD4E2786CB61180EE0B5B5': {
      'panoIdArray': [
        'F8BDCFCADB0B4A68ABA2682ED3A24712',
        'DCBCB1E2998342D79995ADD1A7CA12B8',
      ],
      'indexArray': [],
    },
    '84F75814A9B440EA9C9063DF6D0A03D2': {
      'panoIdArray': [
        '3EB4AD39A2284B3F811EB5BC949C6AA4',
        'B077C848306748049CD149FFE3DAFF9A',
      ],
      'indexArray': [],
    },
    '6CB4409F704541DA8C7A6BCD715057AC': {
      'panoIdArray': [
        'AC6E384A874A4ED7AD38C9ACE1ACE67F',
        'C9EDD57E319E4D48BC857FB373E34960',
        '6506826074274F568B1414D7B7268A7E',
      ],
      'indexArray': [],
    },
    '18ACC6F624AB4BF9BB1C8AEF7919BDA7': {
      'panoIdArray': [
        '5EFA57DC051641ACB819C9901730CF50',
        'FCDF450BBAAE433F9A304C4441BDCA40',
        '90B2A05A279D44528010FF6F8916ECDB',
      ],
      'indexArray': [],
    },
    '45CD1D7337BA44BB89A7AE66F543F237': {
      'panoIdArray': [
        'FCDF450BBAAE433F9A304C4441BDCA40',
        '90B2A05A279D44528010FF6F8916ECDB',
        'EC2ADEABD8CB41458A80C3CB50BE0D28',
      ],
      'indexArray': [],
    },
    '4356ADC4A98C4801971DD142F71AF0A7': {
      'panoIdArray': [
        '90B2A05A279D44528010FF6F8916ECDB',
        '9F2F784551104AB3A791163B79C6A0E1',
      ],
      'indexArray': [],
    },
    '9DFCC52F5B0F4E7682430640FCB01E01': {
      'panoIdArray': [
        'A7A6F17EB8E74ABA98A95F5A654C7570',
      ],
      'indexArray': [],
    },
    'EE78C8D0C62C47469F77EB5E6C2C93A0': {
      'panoIdArray': [
        'AAD1BF6764654A5FBE39A4B90E554601',
        '9B47C517CC59412C9B9DB39804B5DA6E',
        '17C62BD9C73F4F8BA4B1AE1696236A7A',
        'A8993F9C8C384E4D91FC1BE3B74C3C22',
      ],
      'indexArray': [],
    },
    '8E15D87960DC4B76918C7C1B57561F18': {
      'panoIdArray': [
        '13E4F59028574193B1BAFF02C9BAD5F2',
        'FCF1F94CF1524448A2079096FEA10C1A',
        'AAD1BF6764654A5FBE39A4B90E554601',
        'A8993F9C8C384E4D91FC1BE3B74C3C22',
        '17C62BD9C73F4F8BA4B1AE1696236A7A',
        '9B47C517CC59412C9B9DB39804B5DA5E',
      ],
      'indexArray': [],
    },
    '6F4352B8C3BE4B18ADA3D7956BD0F0C2': {
      'panoIdArray': [
        '17EDEB0E1E414B6F80DED583028F6DA8',
        'E6F239D7FBB148A5A5CD6C030117917F',
      ],
      'indexArray': [],
    },
    '82FF9CEC6D95416E9B4F5F3C3CBEDFBD': {
      'panoIdArray': [
        '17EDEB0E1E414B6F80DED583028F6DA8',
        'E6F239D7FBB148A5A5CD6C030117917F',
        'A8993F9C8C384E4D91FC1BE3B74C3C22',
      ],
      'indexArray': [],
    },
    '0D212898D4D0469599EC09C136DD407B': {
      'panoIdArray': [
        '94BC705E6C954CAB83D7AD10D8A578C7',
        'C4A0D15C16A74B0DB268C9F6E9A1D7B1',
        'C2088C2EC0D34AB3A5BCC91369E90F70',
        '1B1480DCE1B54E91808F28463B8D0EC4',
      ],
      'indexArray': [],
    },
    'AC44033EEEA446F49ED520165687AFB1': {
      'panoIdArray': [
        '49FE5212A72841E28C9B756943213883',
        'C163625726B74ED283A0C26B09796775',
      ],
      'indexArray': [],
    },
    '94BC705E6C954CAB83D7AD10D8A578C7': {
      'panoIdArray': [
        '49FE5212A72841E28C9B756943213883',
        'C163625726B74ED283A0C26B09796775',
        'C2088C2EC0D34AB3A5BCC91369E90F70',
      ],
      'indexArray': [],
    },
  },
  visitLineJson: {
    1: [
      '088586E897FB4925A33A2AE24210FED5',
      '4076D2EF3AA9470090D42D0D5650457C',
      '3867029037334FF38CF621288890DE11',
      '0DCEE01B0CBD49DABFCDB17BA842B1E5',
      '9BC484E0660B4E6797A3CB6BEE8C2B0C',
      '8B5B02D6DC01461699DA8E49C417ED11',
      'BBA8B96C072048CA8847118A7550B3A3',
      'BFCBDB4DCA264F09B2AA00900F078EBA',
      '85635C4AC3DF466A821BF6AB38DB03BF',
      'DBFA0D774E9F4863B7937375732BCE36',
      '188BC92DE83E4C638CABDBA9EE9BE5FE',
      '91C743D4FFC04AB4805603AE7023C18C',
      '5D970EDA030D455090AEA44BFEE8662D',
      '21FBEDFF38714C21989D2FECE1E2A26F',
      'D717FCCF45E5452586443C67E803CB63',
      '4A212311113742938CC3FB9D745EB55A',
      '15FC9E0F2AAB48F9ABCE1767B84C7E33',
      '4076D2EF3AA9470090D42D0D5650457C'
    ]
  },
  flootFirstTip: {
    6: 'right', // 二层 ↓ 顺序往下
    5: 'left',
    4: 'left',
    3: 'right',
    2: 'left',
  }
}
